import { defineStore } from "pinia";
import { ref } from "vue";
export const useCurrencyFavoritesStore = defineStore("CurrencyFavoritesStore", () => {
    const favSymbols = ref([]);
    const showFavorites = ref(false);
    return {
        favSymbols,
        showFavorites,
    };
}, {
    persist: true,
});
